import { useState } from 'react';
import Image from 'next/image';
import TooltipWithArrow from 'molecules/TooltipWithArrow';
import ManagedFileUploadDialog from 'organisms/ManagedFileUploadDialog';

import useGuideDocument from 'hooks/useGuideDocument';

function HelpButton() {
    const [openHelp, setOpenHelp] = useState(false);
    const { isSuperAdmin, openGuideDocument, uploadGuideDocument } = useGuideDocument();

    return (
        <>
            <TooltipWithArrow
                tooltipText="Help"
                childNode={<Image
                    src="/images/icons/help-circle.svg"
                    id="deon-help"
                    width={26}
                    height={26}
                    alt="help"
                    className="cursor-pointer relative"
                    onClick={() => {
                        openGuideDocument();
                    }}
                />
                }
                isRightClick={true}
                onContextContentClick={(e) => {
                    if (!isSuperAdmin()) return;
                    e.preventDefault();
                    setOpenHelp(true);
                }}
            />

            <ManagedFileUploadDialog
                show={openHelp}
                title="Upload Document"
                supportedText="Supported format: PDF. Max Size: 25MB"
                templateFileName=""
                onClose={() => setOpenHelp(false)}
                onContinue={(fileList) => { uploadGuideDocument(fileList); }}
            />
        </>
    );
}

export default HelpButton;

